import React, { useEffect } from 'react';
import emailjs from '@emailjs/browser';
import { useLocation } from 'react-router-dom';
import SEO from '../seo/SEO';
import './locationPage.css';

const LocationPage = ({ location }) => {
  const routeLocation = useLocation();

  // EmailJS Inquiry Form Handler
  function handleInquirySubmit(e) {
    e.preventDefault();
    const form = e.target;

    console.log("ENV:", {
        service: process.env.VITE_APP_INQUIRY_EMAILJS_SERVICE_ID,
        template: process.env.VITE_APP_INQUIRY_EMAILJS_TEMPLATE_ID,
        pub: process.env.VITE_APP_EMAILJS_PUBLIC_KEY,
    });

    emailjs
      .send(
        "service_58i7qa5",
        "template_qequrek",
        {
          name: form['quote-name'].value,
          phone: form['quote-phone'].value,
          email: form['quote-email'].value,
          service: form['quote-service'].value,
          bedrooms: form['quote-bedrooms'].value,
          baths: form['quote-baths'].value,
          location: form['quote-location'].value,
          message: form['quote-message'].value,
        },
        "yK2s4VlcT3nuMUeRB"
      )
      .then((res) => {
    console.log("✅ EmailJS success:", res);
    alert("Enquiry sent successfully!");
    form.reset();
  })
  .catch((err) => {
    console.error("❌ EmailJS raw error:", err);
    console.error("❌ EmailJS JSON:", JSON.stringify(err, null, 2));

    // also show something useful on screen
    const msg =
      err?.text ||
      err?.message ||
      err?.status ||
      (typeof err === "string" ? err : null) ||
      "Unknown error (check console + Network tab)";

    alert(`Failed to send enquiry: ${msg}`);
  });
    
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [routeLocation]);

  return (
    <>
      <SEO 
        title={`${location.title} | Niks Elite Cleaning`}
        description={location.metaDescription}
      />
      <div className="location-page">
      {/* Hero Section */}
      <section className="location-hero">
        <div className="hero-overlay"></div>
        <div className="container">
          <div className="hero-content" data-aos="fade-up">
            <h1>{location.h1}</h1>
            <p className="hero-subtitle">{location.subtitle}</p>
            <div className="hero-features">
              <div className="feature-badge">
                <i className="fas fa-star"></i>
                <span>5.0 Rating</span>
              </div>
              <div className="feature-badge">
                <i className="fas fa-users"></i>
                <span>1500+ Customers</span>
              </div>
              <div className="feature-badge">
                <i className="fas fa-clock"></i>
                <span>Same Day Service</span>
              </div>
            </div>
            <div className="hero-cta">
              <a href="tel:+61493519401" className="btn btn-primary">
                <i className="fas fa-phone-alt"></i> Call +61 493 519 401
              </a>
              <a href="#contact" className="btn btn-secondary">
                Get Free Quote
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="location-content section-padding">
        <div className="container">
          <article className="location-article">
            <h2 data-aos="fade-up">{location.introTitle}</h2>
            <div className="content-text" data-aos="fade-up" data-aos-delay="100">
              {location.introContent}
            </div>

            <h2 data-aos="fade-up">Our Cleaning Services in {location.suburb}</h2>
            <div className="services-grid" data-aos="fade-up" data-aos-delay="100">
              {location.services.map((service, index) => (
                <div key={index} className="service-card">
                  <div className="service-icon">
                    <i className={service.icon}></i>
                  </div>
                  <h3>{service.name}</h3>
                  <p>{service.description}</p>
                </div>
              ))}
            </div>

            <h2 data-aos="fade-up">Why Choose Niks Elite Cleaning in {location.suburb}?</h2>
            <div className="why-choose-grid" data-aos="fade-up" data-aos-delay="100">
              {location.whyChoose.map((reason, index) => (
                <div key={index} className="why-item">
                  <div className="why-icon">
                    <i className={reason.icon}></i>
                  </div>
                  <div>
                    <h3>{reason.title}</h3>
                    <p>{reason.description}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="location-info-box" data-aos="fade-up">
              <h2>About {location.suburb}</h2>
              <div className="info-content">{location.aboutArea}</div>
            </div>

            <h2 data-aos="fade-up">Frequently Asked Questions - {location.suburb}</h2>
            <div className="location-faqs" data-aos="fade-up" data-aos-delay="100">
              {location.faqs.map((faq, index) => (
                <div key={index} className="faq-item">
                  <h3>{faq.question}</h3>
                  <p>{faq.answer}</p>
                </div>
              ))}
            </div>

            <div className="cta-section" data-aos="fade-up">
              <h2>Book Your Cleaning Service in {location.suburb} Today</h2>
              <p>
                Ready to experience the best cleaning service in {location.suburb}? Contact us
                now for a free, no-obligation quote.
              </p>
              <div className="cta-buttons">
                <a href="tel:+61493519401" className="btn btn-primary btn-lg">
                  <i className="fas fa-phone-alt"></i> Call Now +61 493 519 401
                </a>
                <a href="#contact" className="btn btn-secondary btn-lg">
                  Request Free Quote
                </a>
              </div>
            </div>
          </article>
        </div>
      </section>

      {/* Contact Form */}
      <section id="contact" className="location-contact section-padding">
        <div className="container">
          <div className="section-title">
            <h2>Get Your Free Quote for {location.suburb}</h2>
            <p>
              Fill out the form below and we'll get back to you within <b>12 hours</b>
            </p>
          </div>

          <div className="contact-form-wrapper">
            <form className="service-form" onSubmit={handleInquirySubmit}>
              <div className="form-row">
                <div className="form-group">
                  <input
                    id="quote-name"
                    name="quote-name"
                    type="text"
                    placeholder="Your Name"
                    required
                  />
                </div>
                <div className="form-group">
                  <input
                    id="quote-phone"
                    name="quote-phone"
                    type="tel"
                    placeholder="Phone Number"
                    required
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <input
                    id="quote-email"
                    name="quote-email"
                    type="email"
                    placeholder="Email Address"
                    required
                  />
                </div>
                <div className="form-group">
                  <select id="quote-service" name="quote-service" required>
                    <option value="">Select Service</option>
                    <option value="end-of-lease">End of Lease Cleaning</option>
                    <option value="carpet">Carpet Cleaning</option>
                    <option value="domestic">Domestic Cleaning</option>
                    <option value="commercial">Commercial Cleaning</option>
                    <option value="office">Office Cleaning</option>
                    <option value="window">Window Cleaning</option>
                    <option value="other">Other</option>
                  </select>
                </div>
              </div>

              <div className="form-group"><br/>
                <input
                  id="quote-bedrooms"
                  name="quote-bedrooms"
                  type="number"
                  min="0"
                  placeholder="Number of Bedrooms"
                  required
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <input
                    id="quote-baths"
                    name="quote-baths"
                    type="number"
                    min="1"
                    placeholder="Number of Baths"
                    required
                  />
                </div>
                <div className="form-group">
                  <input
                    id="quote-location"
                    name="quote-location"
                    type="text"
                    placeholder="Full Property Address"
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <textarea
                  id="quote-message"
                  name="quote-message"
                  placeholder="Additional details or special requirements..."
                  rows="5"
                ></textarea>
              </div>

              <button type="submit" className="btn btn-primary btn-block">
                Send Inquiry <i className="fas fa-paper-plane"></i>
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
    </>
  );
};

export default LocationPage;